import gql from 'graphql-tag';

export default gql`
  query loginSignupTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          loginSignUpForm {
            loginSignupTitle
            loginSignupLoginSubtitle
            loginSignupSignupSubtitle
            loginSignupLoginCta
            loginSignupSignupCta
            loginSignupEmailLabel
            loginSignupPasswordLabel
            loginSignupFirstNameLabel
            loginSignupLastNameLabel
            loginSignupBirthdayLabel
            loginSignupCreatePasswordLabel
            loginSignupRememberMe
            loginSignupOptIn
            loginSignupFirstNamePlaceholder
            loginSignupLastNamePlaceholder
            loginSignupEmailPlaceholder
            loginSignupPasswordPlaceholder
            loginSignupEmailConfirmationPlaceholder
            loginSignupPasswordConfirmationPlaceholder
            loginSignupLoginButton
            loginSignupSignupButton
            loginSignupLoginPasswordPlaceholder
            loginSignupLoginForgotPassword
            loginSignupSignupPasswordCriteria
            genericFieldValidationErrorMessage
            futureDateValidationErrorMessage
            invalidDateValidationErrorMessage
            invalidPasswordValidationErrorMessage
            passwordsDoNotMatchValidationErrorMessage
            passwordsTooShortValidationErrorMessage
            emailAddressDoNoMatchValidationErrorMessage
            customerNotFoundInAllegiant
            invalidEmailOrPasswordErrorMessage
          }
        }
      }
    }
  }
`;
